import React, { useState } from "react";
import { isEmpty, isObject } from "lodash";

import { HomeConfig } from "config/homeConfig";
import { SMS_CODE } from "config/const";
import { FormContainer } from "components/FormElement";
import * as Client from "api/client";
import { useAuth } from "providers/Auth";
import { useToast } from "providers/Toast";
import { useLoading } from "providers/Loading";
import { BlackButton } from "components/Styled";
import PrivacyModal from "components/PrivacyModal";
import ErrorModal from "./ErrorModal";
import Phone from "components/Phone";
import PhoneVerify from "components/PhoneVerify";
import AnnotationItem from "components/AnnotationItem";
import { yearsList, monthsList, daysList, genderList } from "./calendar";
import * as ga from "methods/ga";
import * as fb from "methods/fb";
import * as line from "methods/line";
import { formValidate } from "./validate";

import { GetGiftFormWrapper } from "./styled";

const MODAL_TEXT = {
  privacy: "privacy",
};

const Form = ({ handleSubmit, profile, setOpen, ...props }) => {
  return (
    <FormContainer
      useFormPayloads={{ mode: "all", shouldUnregister: true }}
      onSubmit={handleSubmit}
    >
      {HomeConfig.form.contents.map((item, idx) => (
        <div key={idx} className="row">
          {item.map((detail) => (
            <div key={detail.key} className={`col ${detail.key}`}>
              <FormDetail
                item={detail}
                defaultValue={profile[detail.key] || ""}
                {...props}
              />
            </div>
          ))}
        </div>
      ))}
      {/* <div className="row">* 為必填選項</div> */}
      <div className="row">
        <FormDetail
          item={{
            ...HomeConfig.form.private,
            label: (
              <div>
                {/* {HomeConfig.form.private.label} */}
                <span className="introduce">
                  我同意將此資料提供予La Prairie萊珀妮行銷處理與使用。
                </span>
                <span
                  onClick={() => setOpen(MODAL_TEXT.privacy)}
                  className="introduce note"
                >
                  個資法規定參考
                </span>
              </div>
            ),
          }}
        ></FormDetail>
      </div>
      <BlackButton variant="outlined" type="submit" className="submit_btn">
        確定送出
      </BlackButton>
    </FormContainer>
  );
};

const FormDetail = ({ item, defaultValue, stores }) => {
  switch (item.key) {
    case "gender":
      item.sources = genderList;
      break;
    case "year":
      item.sources = yearsList();
      break;
    case "month":
      item.sources = monthsList;
      break;
    case "day":
      item.sources = daysList();
      break;
    case "branch":
      if (!stores.length) return <div />;
      item.sources = stores.map((store = {}) => ({
        key: store.id,
        label: store.name,
      }));
      const store = stores.find(({ name }) => name === defaultValue);
      if (store) defaultValue = store.id;

      break;
    default:
      break;
  }

  switch (item.key) {
    case "phoneVerify":
      return <PhoneVerify item={item} defaultValue={defaultValue} />;
    case "phone":
      return <Phone item={item} defaultValue={defaultValue} />;
    default:
      return (
        <AnnotationItem
          annotation={item}
          type={item.validate}
          defaultValue={defaultValue}
          extends={item.extends}
        />
      );
  }
};

export default function GetGiftForm({ stores, setExchangeModal, canFillForm }) {
  const [modalOpen, setOpen] = useState(false);

  const {
    auth: { accessToken, userId },
    profile,
  } = useAuth();
  const { danger } = useToast();
  const { withLoading } = useLoading();

  const handleSubmit = (data) => {
    console.log("submit:", data);
    const errors = formValidate(data, { profile });
    if (!isEmpty(errors)) {
      setOpen(errors);
    } else {
      ga.sendGAEvent(userId, ga.GaEventType.SUBMIT);
      ga.gtmButtonClick(ga.ButtonType.SUBMIT);
      if (data.phoneVerify !== SMS_CODE && profile.phone !== data.phone) {
        withLoading(verifyPhone(data));
      } else {
        withLoading(saveForm(data));
      }
    }
  };

  const verifyPhone = async (data) => {
    const res = await Client.verifyPhone(userId, data.phone, data.phoneVerify);

    if (!res.err && !res.error) {
      ga.sendGAEvent(userId, ga.GaEventType.VERIFY_PHONE);
      withLoading(saveForm(data));
      setExchangeModal("submit");
    } else {
      if (res.message.message) danger(res.message.message);
    }
  };
  const saveForm = async ({
    lastName,
    firstName,
    year,
    month,
    day,
    branch,
    email,
    phone,
    gender,
  }) => {
    const store = stores.find(({ id }) => id === branch) || {};
    const params = {
      accessToken: accessToken,
      lastName,
      firstName,
      birthday: `${year}/${month}/${day}`,
      fillinBranch: store.name,
      email,
      phone,
      nameTitle: gender,
    };

    const resp = await Client.saveCustomerForm(userId, params);
    if (resp && resp.status === 200) {
      ga.sendGAEvent(userId, ga.GaEventType.SUBMITED);

      // 快點 tracing code
      ga.finishFormTrack();
      line.finishFormTrack();
      fb.finishFormTrack();

      setExchangeModal("submit");
    } else {
      if (typeof resp.message.message === "string") {
        danger(resp.message.message);
      } else {
        danger("發生錯誤！");
      }
    }
  };

  const goOfficialWeb = () => {
    ga.sendGAEvent(userId, ga.GaEventType.EXPLORE);
    ga.gtmButtonClick(ga.ButtonType.SUBMITED);
    window.open(HomeConfig.form.link);
  };

  return (
    <GetGiftFormWrapper>
      <div className="title">{HomeConfig.form.title}</div>
      <div className="line"></div>
      <div className="subtitle">{HomeConfig.form.subtitle}</div>
      {/* <div className="note">{HomeConfig.form.note}</div> */}
      <img alt="form-img" src={HomeConfig.form.img} />
      <div className="content">
        <div className="introduce">
          {canFillForm
            ? HomeConfig.form.introduce.unsubmit
            : HomeConfig.form.introduce.submited}
        </div>

        <div id="la-prairie-form">
          {canFillForm ? (
            <div>
              <Form
                handleSubmit={handleSubmit}
                profile={profile}
                stores={stores}
                setOpen={setOpen}
              />
              <div className="note small justify">
                {HomeConfig.form.notes.map((note) => (
                  <div key={note} className="row">
                    <div className="col">－</div>
                    <div className="col">{note}</div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <BlackButton
              variant="outlined"
              type="submit"
              sx={{
                width: "100%",
                fontWeight: "normal",
                marginBottom: "20px",
                padding: "0.8rem 2.2rem",
                fontSize: "1.2rem",
              }}
              onClick={goOfficialWeb}
            >
              探索更多
            </BlackButton>
          )}
        </div>
      </div>
      <PrivacyModal open={modalOpen === MODAL_TEXT.privacy} setOpen={setOpen} />
      <ErrorModal
        errors={modalOpen}
        open={modalOpen && isObject(modalOpen)}
        setOpen={setOpen}
      />
    </GetGiftFormWrapper>
  );
}
